var city ={
    "citycode": [],
    "adcode": "450000",
    "name": "广西壮族自治区",
    "center": {
        "lng": 108.327537,
        "lat": 22.816659
    },
    "districtList": [
        {
            "citycode": "0776",
            "adcode": "451000",
            "name": "百色市",
            "center": {
                "lng": 106.61869,
                "lat": 23.90307
            },
            "districtList": [
                {
                    "citycode": "0776",
                    "adcode": "451028",
                    "name": "乐业县",
                    "center": {
                        "lng": 106.556564,
                        "lat": 24.776812
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451030",
                    "name": "西林县",
                    "center": {
                        "lng": 105.097229,
                        "lat": 24.50762
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451027",
                    "name": "凌云县",
                    "center": {
                        "lng": 106.56114,
                        "lat": 24.347444
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451031",
                    "name": "隆林各族自治县",
                    "center": {
                        "lng": 105.343816,
                        "lat": 24.770649
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451002",
                    "name": "右江区",
                    "center": {
                        "lng": 106.618151,
                        "lat": 23.900804
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451082",
                    "name": "平果市",
                    "center": {
                        "lng": 107.589768,
                        "lat": 23.329815
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451081",
                    "name": "靖西市",
                    "center": {
                        "lng": 106.417666,
                        "lat": 23.134375
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451029",
                    "name": "田林县",
                    "center": {
                        "lng": 106.22874,
                        "lat": 24.294627
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451024",
                    "name": "德保县",
                    "center": {
                        "lng": 106.615087,
                        "lat": 23.324084
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451026",
                    "name": "那坡县",
                    "center": {
                        "lng": 105.83234,
                        "lat": 23.387997
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451003",
                    "name": "田阳区",
                    "center": {
                        "lng": 106.915424,
                        "lat": 23.735631
                    }
                },
                {
                    "citycode": "0776",
                    "adcode": "451022",
                    "name": "田东县",
                    "center": {
                        "lng": 107.125609,
                        "lat": 23.596706
                    }
                }
            ]
        },
        {
            "citycode": "0777",
            "adcode": "450700",
            "name": "钦州市",
            "center": {
                "lng": 108.654355,
                "lat": 21.980894
            },
            "districtList": [
                {
                    "citycode": "0777",
                    "adcode": "450702",
                    "name": "钦南区",
                    "center": {
                        "lng": 108.657427,
                        "lat": 21.940438
                    }
                },
                {
                    "citycode": "0777",
                    "adcode": "450703",
                    "name": "钦北区",
                    "center": {
                        "lng": 108.638738,
                        "lat": 22.0024
                    }
                },
                {
                    "citycode": "0777",
                    "adcode": "450722",
                    "name": "浦北县",
                    "center": {
                        "lng": 109.556232,
                        "lat": 22.271902
                    }
                },
                {
                    "citycode": "0777",
                    "adcode": "450721",
                    "name": "灵山县",
                    "center": {
                        "lng": 109.290698,
                        "lat": 22.416671
                    }
                }
            ]
        },
        {
            "citycode": "0779",
            "adcode": "450500",
            "name": "北海市",
            "center": {
                "lng": 109.120248,
                "lat": 21.481305
            },
            "districtList": [
                {
                    "citycode": "0779",
                    "adcode": "450503",
                    "name": "银海区",
                    "center": {
                        "lng": 109.139689,
                        "lat": 21.449729
                    }
                },
                {
                    "citycode": "0779",
                    "adcode": "450512",
                    "name": "铁山港区",
                    "center": {
                        "lng": 109.422099,
                        "lat": 21.529878
                    }
                },
                {
                    "citycode": "0779",
                    "adcode": "450502",
                    "name": "海城区",
                    "center": {
                        "lng": 109.117256,
                        "lat": 21.474914
                    }
                },
                {
                    "citycode": "0779",
                    "adcode": "450521",
                    "name": "合浦县",
                    "center": {
                        "lng": 109.207236,
                        "lat": 21.66132
                    }
                }
            ]
        },
        {
            "citycode": "0774",
            "adcode": "450400",
            "name": "梧州市",
            "center": {
                "lng": 111.279022,
                "lat": 23.476733
            },
            "districtList": [
                {
                    "citycode": "0774",
                    "adcode": "450423",
                    "name": "蒙山县",
                    "center": {
                        "lng": 110.525003,
                        "lat": 24.193567
                    }
                },
                {
                    "citycode": "0774",
                    "adcode": "450406",
                    "name": "龙圩区",
                    "center": {
                        "lng": 111.247514,
                        "lat": 23.414869
                    }
                },
                {
                    "citycode": "0774",
                    "adcode": "450481",
                    "name": "岑溪市",
                    "center": {
                        "lng": 110.994955,
                        "lat": 22.918327
                    }
                },
                {
                    "citycode": "0774",
                    "adcode": "450405",
                    "name": "长洲区",
                    "center": {
                        "lng": 111.274276,
                        "lat": 23.486279
                    }
                },
                {
                    "citycode": "0774",
                    "adcode": "450422",
                    "name": "藤县",
                    "center": {
                        "lng": 110.914606,
                        "lat": 23.375538
                    }
                },
                {
                    "citycode": "0774",
                    "adcode": "450403",
                    "name": "万秀区",
                    "center": {
                        "lng": 111.318065,
                        "lat": 23.470543
                    }
                },
                {
                    "citycode": "0774",
                    "adcode": "450421",
                    "name": "苍梧县",
                    "center": {
                        "lng": 111.547244,
                        "lat": 23.868208
                    }
                }
            ]
        },
        {
            "citycode": "0770",
            "adcode": "450600",
            "name": "防城港市",
            "center": {
                "lng": 108.35467,
                "lat": 21.686732
            },
            "districtList": [
                {
                    "citycode": "0770",
                    "adcode": "450602",
                    "name": "港口区",
                    "center": {
                        "lng": 108.380273,
                        "lat": 21.643426
                    }
                },
                {
                    "citycode": "0770",
                    "adcode": "450681",
                    "name": "东兴市",
                    "center": {
                        "lng": 107.971828,
                        "lat": 21.547821
                    }
                },
                {
                    "citycode": "0770",
                    "adcode": "450621",
                    "name": "上思县",
                    "center": {
                        "lng": 107.983627,
                        "lat": 22.153671
                    }
                },
                {
                    "citycode": "0770",
                    "adcode": "450603",
                    "name": "防城区",
                    "center": {
                        "lng": 108.353978,
                        "lat": 21.768826
                    }
                }
            ]
        },
        {
            "citycode": "0773",
            "adcode": "450300",
            "name": "桂林市",
            "center": {
                "lng": 110.179752,
                "lat": 25.235615
            },
            "districtList": [
                {
                    "citycode": "0773",
                    "adcode": "450305",
                    "name": "七星区",
                    "center": {
                        "lng": 110.317576,
                        "lat": 25.253093
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450327",
                    "name": "灌阳县",
                    "center": {
                        "lng": 111.160764,
                        "lat": 25.489419
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450330",
                    "name": "平乐县",
                    "center": {
                        "lng": 110.632867,
                        "lat": 24.622814
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450332",
                    "name": "恭城瑶族自治县",
                    "center": {
                        "lng": 110.82841,
                        "lat": 24.831581
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450324",
                    "name": "全州县",
                    "center": {
                        "lng": 111.087089,
                        "lat": 25.94939
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450326",
                    "name": "永福县",
                    "center": {
                        "lng": 109.982974,
                        "lat": 24.980447
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450328",
                    "name": "龙胜各族自治县",
                    "center": {
                        "lng": 110.011662,
                        "lat": 25.79803
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450321",
                    "name": "阳朔县",
                    "center": {
                        "lng": 110.496305,
                        "lat": 24.778785
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450381",
                    "name": "荔浦市",
                    "center": {
                        "lng": 110.395232,
                        "lat": 24.48843
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450312",
                    "name": "临桂区",
                    "center": {
                        "lng": 110.212425,
                        "lat": 25.238556
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450302",
                    "name": "秀峰区",
                    "center": {
                        "lng": 110.264102,
                        "lat": 25.273954
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450311",
                    "name": "雁山区",
                    "center": {
                        "lng": 110.286611,
                        "lat": 25.101798
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450304",
                    "name": "象山区",
                    "center": {
                        "lng": 110.281223,
                        "lat": 25.261585
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450303",
                    "name": "叠彩区",
                    "center": {
                        "lng": 110.301489,
                        "lat": 25.314158
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450323",
                    "name": "灵川县",
                    "center": {
                        "lng": 110.319837,
                        "lat": 25.3948
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450325",
                    "name": "兴安县",
                    "center": {
                        "lng": 110.672013,
                        "lat": 25.612576
                    }
                },
                {
                    "citycode": "0773",
                    "adcode": "450329",
                    "name": "资源县",
                    "center": {
                        "lng": 110.652612,
                        "lat": 26.042452
                    }
                }
            ]
        },
        {
            "citycode": "1772",
            "adcode": "451300",
            "name": "来宾市",
            "center": {
                "lng": 109.221243,
                "lat": 23.750105
            },
            "districtList": [
                {
                    "citycode": "1772",
                    "adcode": "451322",
                    "name": "象州县",
                    "center": {
                        "lng": 109.704852,
                        "lat": 23.973832
                    }
                },
                {
                    "citycode": "1772",
                    "adcode": "451324",
                    "name": "金秀瑶族自治县",
                    "center": {
                        "lng": 110.190354,
                        "lat": 24.130509
                    }
                },
                {
                    "citycode": "1772",
                    "adcode": "451381",
                    "name": "合山市",
                    "center": {
                        "lng": 108.885829,
                        "lat": 23.807032
                    }
                },
                {
                    "citycode": "1772",
                    "adcode": "451323",
                    "name": "武宣县",
                    "center": {
                        "lng": 109.663153,
                        "lat": 23.594444
                    }
                },
                {
                    "citycode": "1772",
                    "adcode": "451321",
                    "name": "忻城县",
                    "center": {
                        "lng": 108.665641,
                        "lat": 24.066176
                    }
                },
                {
                    "citycode": "1772",
                    "adcode": "451302",
                    "name": "兴宾区",
                    "center": {
                        "lng": 109.183284,
                        "lat": 23.727647
                    }
                }
            ]
        },
        {
            "citycode": "1774",
            "adcode": "451100",
            "name": "贺州市",
            "center": {
                "lng": 111.567216,
                "lat": 24.404182
            },
            "districtList": [
                {
                    "citycode": "1774",
                    "adcode": "451123",
                    "name": "富川瑶族自治县",
                    "center": {
                        "lng": 111.296012,
                        "lat": 24.811601
                    }
                },
                {
                    "citycode": "1774",
                    "adcode": "451122",
                    "name": "钟山县",
                    "center": {
                        "lng": 111.303085,
                        "lat": 24.526041
                    }
                },
                {
                    "citycode": "1774",
                    "adcode": "451102",
                    "name": "八步区",
                    "center": {
                        "lng": 111.552029,
                        "lat": 24.411822
                    }
                },
                {
                    "citycode": "1774",
                    "adcode": "451103",
                    "name": "平桂区",
                    "center": {
                        "lng": 111.479839,
                        "lat": 24.453094
                    }
                },
                {
                    "citycode": "1774",
                    "adcode": "451121",
                    "name": "昭平县",
                    "center": {
                        "lng": 110.811158,
                        "lat": 24.169675
                    }
                }
            ]
        },
        {
            "citycode": "1755",
            "adcode": "450800",
            "name": "贵港市",
            "center": {
                "lng": 109.598903,
                "lat": 23.11182
            },
            "districtList": [
                {
                    "citycode": "1755",
                    "adcode": "450803",
                    "name": "港南区",
                    "center": {
                        "lng": 109.599357,
                        "lat": 23.075816
                    }
                },
                {
                    "citycode": "1755",
                    "adcode": "450802",
                    "name": "港北区",
                    "center": {
                        "lng": 109.572227,
                        "lat": 23.11136
                    }
                },
                {
                    "citycode": "1755",
                    "adcode": "450804",
                    "name": "覃塘区",
                    "center": {
                        "lng": 109.452668,
                        "lat": 23.127405
                    }
                },
                {
                    "citycode": "1755",
                    "adcode": "450881",
                    "name": "桂平市",
                    "center": {
                        "lng": 110.079315,
                        "lat": 23.394208
                    }
                },
                {
                    "citycode": "1755",
                    "adcode": "450821",
                    "name": "平南县",
                    "center": {
                        "lng": 110.392489,
                        "lat": 23.540413
                    }
                }
            ]
        },
        {
            "citycode": "0778",
            "adcode": "451200",
            "name": "河池市",
            "center": {
                "lng": 108.63639,
                "lat": 24.48523
            },
            "districtList": [
                {
                    "citycode": "0778",
                    "adcode": "451222",
                    "name": "天峨县",
                    "center": {
                        "lng": 107.172287,
                        "lat": 24.999181
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451225",
                    "name": "罗城仫佬族自治县",
                    "center": {
                        "lng": 108.904613,
                        "lat": 24.777501
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451223",
                    "name": "凤山县",
                    "center": {
                        "lng": 107.042157,
                        "lat": 24.546913
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451224",
                    "name": "东兰县",
                    "center": {
                        "lng": 107.374259,
                        "lat": 24.510698
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451229",
                    "name": "大化瑶族自治县",
                    "center": {
                        "lng": 107.998151,
                        "lat": 23.735699
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451228",
                    "name": "都安瑶族自治县",
                    "center": {
                        "lng": 108.105229,
                        "lat": 23.932704
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451226",
                    "name": "环江毛南族自治县",
                    "center": {
                        "lng": 108.258426,
                        "lat": 24.825923
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451221",
                    "name": "南丹县",
                    "center": {
                        "lng": 107.540578,
                        "lat": 24.975066
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451202",
                    "name": "金城江区",
                    "center": {
                        "lng": 108.085166,
                        "lat": 24.692865
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451203",
                    "name": "宜州区",
                    "center": {
                        "lng": 108.611303,
                        "lat": 24.500981
                    }
                },
                {
                    "citycode": "0778",
                    "adcode": "451227",
                    "name": "巴马瑶族自治县",
                    "center": {
                        "lng": 107.258671,
                        "lat": 24.142216
                    }
                }
            ]
        },
        {
            "citycode": "0772",
            "adcode": "450200",
            "name": "柳州市",
            "center": {
                "lng": 109.428071,
                "lat": 24.326442
            },
            "districtList": [
                {
                    "citycode": "0772",
                    "adcode": "450225",
                    "name": "融水苗族自治县",
                    "center": {
                        "lng": 109.256609,
                        "lat": 25.066624
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450226",
                    "name": "三江侗族自治县",
                    "center": {
                        "lng": 109.607675,
                        "lat": 25.783197
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450224",
                    "name": "融安县",
                    "center": {
                        "lng": 109.397538,
                        "lat": 25.224549
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450222",
                    "name": "柳城县",
                    "center": {
                        "lng": 109.267125,
                        "lat": 24.654329
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450206",
                    "name": "柳江区",
                    "center": {
                        "lng": 109.326365,
                        "lat": 24.255644
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450223",
                    "name": "鹿寨县",
                    "center": {
                        "lng": 109.750527,
                        "lat": 24.472897
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450202",
                    "name": "城中区",
                    "center": {
                        "lng": 109.427398,
                        "lat": 24.366964
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450205",
                    "name": "柳北区",
                    "center": {
                        "lng": 109.402009,
                        "lat": 24.362611
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450203",
                    "name": "鱼峰区",
                    "center": {
                        "lng": 109.452781,
                        "lat": 24.318276
                    }
                },
                {
                    "citycode": "0772",
                    "adcode": "450204",
                    "name": "柳南区",
                    "center": {
                        "lng": 109.385504,
                        "lat": 24.336229
                    }
                }
            ]
        },
        {
            "citycode": "0771",
            "adcode": "450100",
            "name": "南宁市",
            "center": {
                "lng": 108.366407,
                "lat": 22.8177
            },
            "districtList": [
                {
                    "citycode": "0771",
                    "adcode": "450124",
                    "name": "马山县",
                    "center": {
                        "lng": 108.177764,
                        "lat": 23.708448
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450110",
                    "name": "武鸣区",
                    "center": {
                        "lng": 108.274869,
                        "lat": 23.159257
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450125",
                    "name": "上林县",
                    "center": {
                        "lng": 108.605089,
                        "lat": 23.432451
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450105",
                    "name": "江南区",
                    "center": {
                        "lng": 108.273206,
                        "lat": 22.781166
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450109",
                    "name": "邕宁区",
                    "center": {
                        "lng": 108.487438,
                        "lat": 22.758633
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450108",
                    "name": "良庆区",
                    "center": {
                        "lng": 108.393889,
                        "lat": 22.753613
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450107",
                    "name": "西乡塘区",
                    "center": {
                        "lng": 108.31344,
                        "lat": 22.833852
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450123",
                    "name": "隆安县",
                    "center": {
                        "lng": 107.695721,
                        "lat": 23.166356
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450181",
                    "name": "横州市",
                    "center": {
                        "lng": 109.262448,
                        "lat": 22.681257
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450102",
                    "name": "兴宁区",
                    "center": {
                        "lng": 108.368071,
                        "lat": 22.85354
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450103",
                    "name": "青秀区",
                    "center": {
                        "lng": 108.495204,
                        "lat": 22.785833
                    }
                },
                {
                    "citycode": "0771",
                    "adcode": "450126",
                    "name": "宾阳县",
                    "center": {
                        "lng": 108.810336,
                        "lat": 23.217771
                    }
                }
            ]
        },
        {
            "citycode": "0775",
            "adcode": "450900",
            "name": "玉林市",
            "center": {
                "lng": 110.18097,
                "lat": 22.654001
            },
            "districtList": [
                {
                    "citycode": "0775",
                    "adcode": "450903",
                    "name": "福绵区",
                    "center": {
                        "lng": 110.059564,
                        "lat": 22.585316
                    }
                },
                {
                    "citycode": "0775",
                    "adcode": "450902",
                    "name": "玉州区",
                    "center": {
                        "lng": 110.150717,
                        "lat": 22.628476
                    }
                },
                {
                    "citycode": "0775",
                    "adcode": "450923",
                    "name": "博白县",
                    "center": {
                        "lng": 109.975856,
                        "lat": 22.273539
                    }
                },
                {
                    "citycode": "0775",
                    "adcode": "450921",
                    "name": "容县",
                    "center": {
                        "lng": 110.558093,
                        "lat": 22.85844
                    }
                },
                {
                    "citycode": "0775",
                    "adcode": "450924",
                    "name": "兴业县",
                    "center": {
                        "lng": 109.875223,
                        "lat": 22.736395
                    }
                },
                {
                    "citycode": "0775",
                    "adcode": "450981",
                    "name": "北流市",
                    "center": {
                        "lng": 110.353765,
                        "lat": 22.708415
                    }
                },
                {
                    "citycode": "0775",
                    "adcode": "450922",
                    "name": "陆川县",
                    "center": {
                        "lng": 110.26412,
                        "lat": 22.321563
                    }
                }
            ]
        },
        {
            "citycode": "1771",
            "adcode": "451400",
            "name": "崇左市",
            "center": {
                "lng": 107.364973,
                "lat": 22.377139
            },
            "districtList": [
                {
                    "citycode": "1771",
                    "adcode": "451421",
                    "name": "扶绥县",
                    "center": {
                        "lng": 107.90389,
                        "lat": 22.635542
                    }
                },
                {
                    "citycode": "1771",
                    "adcode": "451402",
                    "name": "江州区",
                    "center": {
                        "lng": 107.353694,
                        "lat": 22.40609
                    }
                },
                {
                    "citycode": "1771",
                    "adcode": "451423",
                    "name": "龙州县",
                    "center": {
                        "lng": 106.854001,
                        "lat": 22.343591
                    }
                },
                {
                    "citycode": "1771",
                    "adcode": "451481",
                    "name": "凭祥市",
                    "center": {
                        "lng": 106.766715,
                        "lat": 22.094421
                    }
                },
                {
                    "citycode": "1771",
                    "adcode": "451422",
                    "name": "宁明县",
                    "center": {
                        "lng": 107.076394,
                        "lat": 22.140242
                    }
                },
                {
                    "citycode": "1771",
                    "adcode": "451424",
                    "name": "大新县",
                    "center": {
                        "lng": 107.200654,
                        "lat": 22.829287
                    }
                },
                {
                    "citycode": "1771",
                    "adcode": "451425",
                    "name": "天等县",
                    "center": {
                        "lng": 107.143539,
                        "lat": 23.080818
                    }
                }
            ]
        }
    ]
}

export default city;


// WEBPACK FOOTER //
// ./src/util/province/guangxi.js